import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useIsMobile } from "@/hooks/use-mobile";
import { useEffect, useState } from "react";

const useAddEditVendor = () => {
  const { id, vendorId, action } = useParams();
  const navigate = useNavigate();
  const isAdd = !vendorId;
  const isView = vendorId && action == "view";
  const isEdit = vendorId && action == "edit";
  const isAddWithUserId = vendorId && action == "add";
  const isMobile = useIsMobile();
  const [currentStep, setCurrentStep] = useState<number>(1);
  const location = useLocation();
  const { state } = location;

  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const isMasterData = location?.pathname?.toLowerCase()?.includes("master-data");
  const vendorListPath = isMasterData
    ? `/${routes.cam}/${routes.masterData}/${routes.vendorMgmt}`
    : `/${routes.cam}/${routes.communities}/${id}/${routes.vendorMgmt}`;

  const currentPageBreadcrumb = {
    link: "",
    name: (
      <span className="text-primary">
        {isAdd || isAddWithUserId ? "Add Vendor" : isView ? "View Vendor" : "Edit Vendor"}
      </span>
    ),
  };

  const breadcrumbData = isMasterData
    ? [
        {
          link: `/${routes.cam}/${routes.masterData}`,
          name: "Master Data",
        },
        {
          link: "",
          name: "People",
        },
        {
          link: vendorListPath,
          name: <span>{"Vendor Management"}</span>,
        },
        currentPageBreadcrumb,
      ]
    : [
        {
          link: `/${routes.cam}/${routes.communities}`,
          name: `Community - ${(communityDetail as any)?.name || ""}`,
        },
        {
          link: vendorListPath,
          name: <span>{"Vendor Management"}</span>,
        },
        currentPageBreadcrumb,
      ];

  useEffect(() => {
    if (isEdit || isAddWithUserId) {
      if (state?.step) {
        setCurrentStep(parseInt(state?.step) || 2);
      } else {
        setCurrentStep(1);
      }
    }
  }, [state, action]);

  const onBackClick = () => {
    navigate(vendorListPath);
  };

  const onNextStepClick = () => {
    setCurrentStep(currentStep + 1);
  };

  const onPreviousStepClick = () => {
    setCurrentStep(currentStep - 1);
  };

  const onStepperClick = (curr_step: number) => {
    if (isView || isEdit) setCurrentStep(curr_step);
  };

  return {
    isAdd,
    breadcrumbData,
    isView,
    onBackClick,
    onCancel: onBackClick,
    vendorId,
    isMobile,
    onNextStepClick,
    onPreviousStepClick,
    onStepperClick,
    currentStep,
  };
};

export default useAddEditVendor;
